import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import { useTranslator } from "../../context/translator";
import { CreditCardFilled, UsergroupAddOutlined } from "@ant-design/icons";
import Can from "../can/Can";
import { PERMISSION_CODE } from "../../utils/enum/enums";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const ClientTap = ({ tapSelected, handleChangeTap, clientId }) => {
  const { user } = useSelector((state) => state.user);
  const [companyAllow, setCompanyAllow] = useState([]);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );
  const { translate } = useTranslator();
  const [css] = useState({
    selected:
      "inline-flex items-center justify-center p-4 text-blue-600 border-b-2 border-blue-600 rounded-t-lg active dark:text-blue-500 dark:border-blue-500 group",
    unSelected:
      "inline-flex items-center justify-center p-4 border-b-2 border-transparent rounded-t-lg hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300 group",
  });

  useEffect(() => {
    if (company && company?.allow) {
      setCompanyAllow({ ...company?.allow });
    }
  }, [company]);

  if (userLoading || companyLoading) return null;

  return (
    <>
      <div className="border-b border-gray-200 dark:border-gray-700 mb-2">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
          <Can permissions={[PERMISSION_CODE.VIEW_CUSTOMERS]}>
            <li className="me-2">
              <button
                className={`${
                  tapSelected === 1 ? css.selected : css.unSelected
                }`}
                onClick={() => handleChangeTap(1)}
              >
                <svg
                  className="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                </svg>
                {translate("profile")}
              </button>
            </li>
          </Can>
          {IsAllow(companyAllow, "customer-02") && (
            <>
              <li className="me-2">
                <button
                  className={`${
                    tapSelected === 2 ? css.selected : css.unSelected
                  }`}
                  onClick={() => handleChangeTap(2)}
                  disabled={clientId === "new"}
                >
                  <svg
                    className="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 18 20"
                  >
                    <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" />
                  </svg>
                  {translate("contracts")}
                </button>
              </li>
            </>
          )}
          <Can permissions={[PERMISSION_CODE.VIEW_REFERRALS]}>
            {IsAllow(companyAllow, "customer-01") && (
              <>
                <li className="me-2">
                  <button
                    className={`${
                      tapSelected === 5 ? css.selected : css.unSelected
                    }`}
                    onClick={() => handleChangeTap(5)}
                    disabled={clientId === "new"}
                  >
                    <UsergroupAddOutlined className="w-6 h-6 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300" />
                    {translate("referrals")}
                  </button>
                </li>
              </>
            )}
          </Can>
          <Can permissions={[PERMISSION_CODE.VIEW_SENSITIVE_CUSTOMERS]}>
            {IsAllow(companyAllow, "customer-01") && (
              <>
                <li className="me-2">
                  <button
                    className={`${
                      tapSelected === 6 ? css.selected : css.unSelected
                    }`}
                    onClick={() => handleChangeTap(6)}
                    disabled={clientId === "new"}
                  >
                    <CreditCardFilled className="w-6 h-6 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300" />
                    {translate("documents")}
                  </button>
                </li>
              </>
            )}
          </Can>
          <Can permissions={[PERMISSION_CODE.VIEW_CUSTOMER_HISTORY]}>
            <li className="me-2">
              <button
                className={`${
                  tapSelected === 3 ? css.selected : css.unSelected
                }`}
                onClick={() => handleChangeTap(3)}
                disabled={clientId === "new"}
              >
                <svg
                  className="w-4 h-4 me-2 text-gray-400 group-hover:text-gray-500 dark:text-gray-500 dark:group-hover:text-gray-300"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 18 20"
                >
                  <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" />
                </svg>
                {translate("history")}
              </button>
            </li>
          </Can>
        </ul>
      </div>
    </>
  );
};

export default ClientTap;
